/** Left-pane stacked overlay chrome (06 §2.1) — header (back + title) + body. */
import type { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import styles from './OverlayPanel.module.css';

interface Props {
  title: string;
  subtitle?: string;
  onBack: () => void;
  /** Right-aligned header action (e.g. a Next button). */
  action?: ReactNode;
  children: ReactNode;
}

export function OverlayPanel({ title, subtitle, onBack, action, children }: Props) {
  return (
    <div className={styles.panel}>
      <header className={styles.header}>
        <button className={styles.back} onClick={onBack} aria-label="Back">
          <ArrowLeft size={22} />
        </button>
        <span className={styles.titles}>
          <span className={styles.title}>{title}</span>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </span>
        {action}
      </header>
      <div className={styles.body}>{children}</div>
    </div>
  );
}
